'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _findInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/find');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var dataSet_interface = require('./data-set.interface.js');
var dataSource_interface = require('./data-source.interface.js');
var dataSourceLogic_model = require('./data-source-logic.model.js');
var generateSchema = require('generate-schema');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _findInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_findInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);

var INVALID_JSON_SAMPLE_DATA_IDENTIFIER = '__GSQL_parsing_failed__';
var DataSetLogic = /*#__PURE__*/function () {
  function DataSetLogic() {
    _classCallCheck__default["default"](this, DataSetLogic);
  }
  return _createClass__default["default"](DataSetLogic, null, [{
    key: "createLocalFileSampleDataTabularParsingOptions",
    value:
    /**
     * Create local file sample data tabular CSV parsing options.
     *
     * @static
     * @param {TabularParser} dataParser with CSV parsing options
     * @returns {TabularParsingOptions}
     * @memberof DataSetLogic
     */
    function createLocalFileSampleDataTabularParsingOptions(dataParser) {
      var _context, _context2, _context3;
      return {
        fileFormat: dataParser.format,
        separator: _findInstanceProperty__default["default"](_context = dataSourceLogic_model.DataSourceLogic.separators).call(_context, function (sep) {
          return sep[1] === dataParser.separator;
        })[0],
        eol: _findInstanceProperty__default["default"](_context2 = dataSourceLogic_model.DataSourceLogic.eols).call(_context2, function (eol) {
          return eol[1] === dataParser.eol;
        })[0],
        header: dataParser.header,
        quote: dataParser.quote === '' ? undefined : _findInstanceProperty__default["default"](_context3 = dataSourceLogic_model.DataSourceLogic.quotes).call(_context3, function (quote) {
          return quote[1] === dataParser.quote;
        })[0]
      };
    }

    /**
     * Create CSV parsing options.
     *
     * @static
     * @param {TabularParser} dataParser with CSV parsing options
     * @returns {TabularParsingOptions}
     * @memberof DataSetLogic
     */
  }, {
    key: "createTabularParsingOptions",
    value: function createTabularParsingOptions(dataParser) {
      return {
        fileFormat: dataParser.format,
        separator: dataParser.separator,
        eol: dataParser.eol,
        header: dataParser.header,
        quote: dataParser.quote
      };
    }

    /**
     * Create JSON parsing options.
     *
     * @static
     * @param {JSONParser} dataParser with JSON parsing options
     * @returns {JSONParsingOptions}
     * @memberof DataSetLogic
     */
  }, {
    key: "createJSONParsingOptions",
    value: function createJSONParsingOptions(dataParser) {
      return {
        fileFormat: dataParser.format,
        eol: dataParser.eol
      };
    }

    /**
     * Create a tabular data schema.
     *
     * @static
     * @param {string[]} names
     * @returns {TabularDataFieldSchema[]}
     * @memberof DataSetLogic
     */
  }, {
    key: "createTabularDataSchema",
    value: function createTabularDataSchema(names) {
      return _mapInstanceProperty__default["default"](names).call(names, function (name) {
        return {
          name: name
        };
      });
    }

    /**
     * Create a data set label.
     *
     * @static
     * @param {boolean} isChanged
     * @param {DataSourceType} dataSourceType
     * @param {string} uri
     * @returns {string}
     * @memberof DataSetLogic
     */
  }, {
    key: "createDataSetLabel",
    value: function createDataSetLabel(isChanged, uri) {
      var _context4;
      var changed = isChanged ? '* ' : '';
      return _concatInstanceProperty__default["default"](_context4 = "".concat(changed)).call(_context4, uri);
    }

    /**
     * Convert the JSON sample data to the standard JSON schema.
     *
     * @static
     * @param {any[]} jsonSampleData
     * @returns {any}
     * @memberof DataSetLogic
     */
  }, {
    key: "convertSampleDataToStandardSchema",
    value: function convertSampleDataToStandardSchema(jsonSampleData) {
      var standardJSONSchema = {
        $schema: '',
        type: dataSet_interface.JSONDataType.Object,
        properties: {}
      };
      _forEachInstanceProperty__default["default"](jsonSampleData).call(jsonSampleData, function (data) {
        if (_Object$keys__default["default"](standardJSONSchema['properties']).length === 0 && !data[INVALID_JSON_SAMPLE_DATA_IDENTIFIER]) {
          // Generate the json schema based on the valid json sample data.
          standardJSONSchema = generateSchema.json(data);
        }
      });
      return standardJSONSchema;
    }

    /**
     * Convert the standard JSON schema to the in-memory JSON schema.
     *
     * @static
     * @param {any} standardJSONSchema
     * @returns {JSONDataFieldSchema[]}
     * @memberof DataSetLogic
     */
  }, {
    key: "convertStandardSchemaToInMemorySchema",
    value: function convertStandardSchemaToInMemorySchema(standardJSONSchema) {
      var _context5;
      var path = [];
      var jsonSchema = [];
      _forEachInstanceProperty__default["default"](_context5 = _Object$keys__default["default"](standardJSONSchema.properties)).call(_context5, function (key) {
        DataSetLogic.convertSchemaHelper(key, path, jsonSchema, standardJSONSchema.properties[key]);
      });
      return jsonSchema;
    }

    /**
     * Get the file Uri pattern for different remote data source.
     *
     * @static
     * @param {string} dataSourceType
     * @param {string} fileUri
     * @returns {RegExpMatchArray}
     * @memberof DataSetLogic
     */
  }, {
    key: "isValidRemoteUri",
    value: function isValidRemoteUri(dataSourceType, remoteUri) {
      var regex = '';
      switch (dataSourceType) {
        case dataSource_interface.DataSourceType.S3:
          regex = "^(s|S)3://(([^/]+)/?)+$";
          break;
        case dataSource_interface.DataSourceType.GoogleCloudStorage:
          regex = "^gs://(([^/]+)/?)+$";
          break;
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          regex = "^(https|http)://(([^/]+)/?)+$";
          break;
      }
      // Ignore case;
      return new RegExp(regex, 'i').test(remoteUri);
    }

    /**
     * Reconstruct the uri given by the user to get the
     * uri we need to create a connector.
     *
     * @param {string} uri
     * @param {string} dataSourceType
     * @returns {string}
     * @memberof DataSetLogic
     */
  }, {
    key: "getFileUriForConnector",
    value: function getFileUriForConnector(uri, dataSourceType) {
      switch (dataSourceType) {
        case dataSource_interface.DataSourceType.S3:
          return uri.replace('s3://', 's3a://');
        case dataSource_interface.DataSourceType.AzureBlobStorage:
          return DataSetLogic.convertABSInputPathToFileUri(uri);
        default:
          // TODO: Add more data source types.
          return uri;
      }
    }

    /**
     * Parse the Azure Blob Storage input file URL to proper uri needed by kafka connector.
     * INPUT: https://abstest1.blob.core.windows.net/container1/invalidTest.json
     * OUTPUT: abfss://container1@abstest1.dfs.core.windows.net/invalidTest.json
     *
     * @static
     * @param {string} filePath
     * @returns {string}
     * @memberof DataSetLogic
     */
  }, {
    key: "convertABSInputPathToFileUri",
    value: function convertABSInputPathToFileUri(filePath) {
      var fileUri = 'abfss://';
      // Split the protocol and link;
      var pathWithoutProtocal = filePath.split('://')[1];
      var linkSegments = pathWithoutProtocal.split('/');
      // Split from '/' to get the container name from second segment.
      fileUri += linkSegments[1] + '@';
      // Split the first segment with '.' to get account name.
      fileUri += linkSegments[0].split('.')[0] + '.dfs.core.windows.net/';
      // The rest will be the file path. In case there's multiple layer, we will restore the '/'.
      fileUri += _sliceInstanceProperty__default["default"](linkSegments).call(linkSegments, 2).join('/');
      return fileUri;
    }

    /**
     * A dfs helper to convert the standard JSON schema to the in-memory JSON schema.
     *
     * @private
     * @static
     * @param {string} key
     * @param {string[]} path
     * @param {JSONDataFieldSchema[]} jsonSchema
     * @param {any} standardJSONSchema
     * @memberof DataSetLogic
     */
  }, {
    key: "convertSchemaHelper",
    value: function convertSchemaHelper(name, path, jsonSchema, standardJSONSchema) {
      var _this = this;
      path.push(name);
      jsonSchema.push({
        name: name,
        type: DataSetLogic.getJSONDataType(standardJSONSchema.type),
        level: path.length - 1,
        path: _sliceInstanceProperty__default["default"](path).call(path)
      });
      if (DataSetLogic.getJSONDataType(standardJSONSchema.type) === dataSet_interface.JSONDataType.Object) {
        var _context6;
        _forEachInstanceProperty__default["default"](_context6 = _Object$keys__default["default"](standardJSONSchema.properties)).call(_context6, function (propertyName) {
          _this.convertSchemaHelper(propertyName, path, jsonSchema, standardJSONSchema.properties[propertyName]);
        });
      }
      path.pop();
    }

    /**
     * Get JSON data type.
     *
     * @static
     * @param {string} type
     * @return {JSONDataType}
     * @memberof DataSourceLogic
     * @memberof DataSetLogic
     */
  }, {
    key: "getJSONDataType",
    value: function getJSONDataType(type) {
      switch (type) {
        case dataSet_interface.JSONDataType.Boolean:
        case dataSet_interface.JSONDataType.Number:
        case dataSet_interface.JSONDataType.Integer:
        case dataSet_interface.JSONDataType.String:
        case dataSet_interface.JSONDataType.Object:
        case dataSet_interface.JSONDataType.Array:
          return type;
        default:
          return dataSet_interface.JSONDataType.Null;
      }
    }
  }]);
}();

exports.DataSetLogic = DataSetLogic;
exports.INVALID_JSON_SAMPLE_DATA_IDENTIFIER = INVALID_JSON_SAMPLE_DATA_IDENTIFIER;
